import axios from "axios";
export default {
    data() {
        return {
            costCenter: [],
            peruntukan: [],
            treeExpandedKeys: [],
            selected: [],
            EnCommission: true,
            Viwithout_note: true,
        }
    },
    beforeCreate() {
        this.formCollective = this.$form.createForm(this);
    },
    methods: {
        filterOption(input, option) {
            return (
                option.componentOptions.children[0].text
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
            );
        },
        getParent(root) {
            let data = [];
            root.forEach((item) => {
                if (item.key) {
                    data.push(item.key);
                }

                if (item.children.length > 0) {
                    item.children.forEach((d) => {
                        data.push(d.key);
                    });
                }
            });
            return data;
        },
        handleCheck(e) {
            const item = e.target.value;
            this.selected.indexOf(item) == -1 ? this.selected.push(item) : this.selected.splice(this.selected.indexOf(item), 1)
        },
        handleSet() {
            this.formCollective.validateFields((err, values) => {
                if (err) {
                    this.newLoading = false;
                    this.pageLoading = false;
                    this.displayMessage("form-warning");
                    return;
                }

                this.loading.setloading = true
                axios({
                    method: "put",
                    url: this.type == 'revised' ?  this.$serviceUrl + "bailout_report/revisi_detil_pemakaian_kolektif" : this.$serviceUrl + "bailout_report/detil_pemakaian_kolektif",
                    processData: false,
                    data: {
                        'id_lkb_draft': this.id,
                        'id_trans_dtl': values.id_trans_dtl,
                        'iscommision': values.iscommision,
                        'without_note': "1",
                        'selected_item': this.selected,
                    },
                    auth: {
                        username: this.getAuth.username,
                        password: this.getAuth.password,
                    },
                    headers: {
                        "Content-Type": "application/json",
                        "X-API-KEY": this.getAuth.apikey,
                    },
                }).then(response => {
                    this.fetchBailoutFundList();
                    // this.reset();
                    this.formCollective.setFieldsValue({
                        iscommision: "0",
                        without_note: "0",
                        id_bailout: null,
                    });
                    this.loading.setloading = false
                    this.selected = []
                    Event.$emit("reloadCollectivePPSPPD");
                    this.displayMessage("success-save")
                }).catch(err => {
                    this.loading.setloading = false
                    this.displayMessageValue("error-other", err.response.data.message)
                });
            })
        },
        reset() {
            this.costCenter = [],
                this.peruntukan = [],
                this.treeExpandedKeys = [],
                this.selected = [],
                this.formCollective.resetFields();
        },
        handleCloseCollective() {
            this.isCollective = false;
        },
        
    }
}